import { MultiViewCalendar } from "@progress/kendo-react-dateinputs";
import * as React from "react";
export const GoalsDialogCalendar = (props) => {
  return <MultiViewCalendar {...props} bottomView="decade" />;
};